import React, { Component } from "react";
import PropTypes from "prop-types";
import { Loader } from "semantic-ui-react";

class GlobalLoader extends Component {
  state = {
    contentArrayIndex: 0
  };

  componentDidMount() {
    const { interval } = this.props;

    this.intervalId = setInterval(this.contentSwitcher, interval);
  }

  componentWillUnmount() {
    this.stopInterval();
  }

  contentSwitcher = () => {
    const { contentArray } = this.props;
    const { contentArrayIndex } = this.state;
    if (contentArrayIndex < contentArray.length - 1) {
      this.increamentIndex();
    }
  };

  increamentIndex = () => {
    this.setState(({ contentArrayIndex }) => ({
      contentArrayIndex: contentArrayIndex + 1
    }));
  };

  stopInterval = () => {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  };

  render() {
    const {
      contentArray,
      content,
      showContent,
      isMobileView,
      isRtl,
      ...rest
    } = this.props;
    const { contentArrayIndex } = this.state;
    const finalContent =
      (contentArray && contentArray[contentArrayIndex]) || content; // defaults to a single content
    const combinedProps = { ...rest, content: showContent ? finalContent : "" };
    return (
      <div
        style={{
          padding: "30px",
          alignSelf: "center",
          zIndex: 1,
          fontSize: isMobileView ? "1.3em" : "1em",
          lineHeight: isMobileView ? "1.7em" : "initial",
          marginBlockStart: isMobileView ? "inherit" : "110px",
          marginInlineEnd: isMobileView ? " inherit" : "270px"
        }}
      >
        <Loader {...combinedProps} />
      </div>
    );
  }
}

GlobalLoader.defaultProps = {
  contentArray: [],
  interval: 1000,
  content: "Loading",
  showContent: true
};

GlobalLoader.propTypes = {
  interval: PropTypes.number,
  contentArray: PropTypes.array,
  content: PropTypes.string,
  showContent: PropTypes.bool,
  isMobileView: PropTypes.bool,
  isRtl: PropTypes.bool
};

export default GlobalLoader;



// WEBPACK FOOTER //
// ./src/components/common/GlobalLoader/GlobalLoader.js